import { Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";

export function Footer() {
  const { lang, t } = useI18n();
  return (
    <footer className="relative z-20 mt-16 border-t border-border/60 backdrop-blur-sm" style={{ backgroundColor: "rgba(228, 247, 245, 0.7)" }}>
      <div className="mx-auto max-w-6xl px-5 py-10">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <p className="font-display text-base italic">{t.footer_tag}</p>
            <p className="mt-2 text-xs text-muted-foreground">{t.footer_help_line} <Link to="/$lang/support" params={{ lang }} className="underline-offset-2 hover:underline" style={{ color: "var(--amber)" }}>→</Link></p>
          </div>
          <nav className="text-sm" aria-label="Read">
            <p className="mb-2 text-xs uppercase tracking-wider text-muted-foreground">Read</p>
            <ul className="space-y-1">
              <li><Link to="/$lang/stories" params={{ lang }} className="hover:text-foreground">{t.nav_stories}</Link></li>
              <li><Link to="/$lang/categories" params={{ lang }} className="hover:text-foreground">{t.nav_categories}</Link></li>
              <li><Link to="/$lang/learn" params={{ lang }} className="hover:text-foreground">{t.nav_learn}</Link></li>
              <li><Link to="/$lang/glossary" params={{ lang }} className="hover:text-foreground">{t.nav_glossary}</Link></li>
            </ul>
          </nav>
          <nav className="text-sm" aria-label="Act">
            <p className="mb-2 text-xs uppercase tracking-wider text-muted-foreground">Act</p>
            <ul className="space-y-1">
              <li><Link to="/$lang/submit" params={{ lang }} className="hover:text-foreground">{t.nav_submit_cta}</Link></li>
              <li><Link to="/$lang/help" params={{ lang }} className="hover:text-foreground">{t.nav_help_cta}</Link></li>
              <li><Link to="/$lang/support" params={{ lang }} className="hover:text-foreground">{t.nav_support}</Link></li>
              <li><Link to="/$lang/contact" params={{ lang }} className="hover:text-foreground">{t.nav_contact}</Link></li>
            </ul>
          </nav>
          <nav className="text-sm" aria-label="About">
            <p className="mb-2 text-xs uppercase tracking-wider text-muted-foreground">About</p>
            <ul className="space-y-1">
              <li><Link to="/$lang/about" params={{ lang }} className="hover:text-foreground">{t.nav_about}</Link></li>
              <li><Link to="/$lang/faq" params={{ lang }} className="hover:text-foreground">{t.nav_faq}</Link></li>
              <li><Link to="/$lang/legal" params={{ lang }} className="hover:text-foreground">Legal</Link></li>
              <li><Link to="/$lang/shop" params={{ lang }} className="hover:text-foreground">Shop</Link></li>
            </ul>
          </nav>
        </div>
        <div className="mt-8 flex flex-col items-start justify-between gap-2 border-t border-border/60 pt-5 text-xs text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} MadCaptains.net — {t.footer_rights}</p>
          <p className="font-display italic">Entry № 0001 · {new Date().getFullYear()}</p>
        </div>
      </div>
    </footer>
  );
}